import React from "react";
import Marquee from "react-fast-marquee";
import { Egg } from "lucide-react";

const PHRASES = [
  "Indian Street Food",
  "Egg Heaven",
  "Clayton's Favourite",
  "30+ Egg Dishes",
  "Cooked Fresh Daily",
  "Big Flavour Energy",
];

export default function MarqueeBand() {
  return (
    <div className="relative py-6 md:py-8 border-y border-yellow-brand/30 bg-yellow-brand">
      <Marquee gradient={false} speed={48} pauseOnHover={false}>
        {Array.from({ length: 3 }).flatMap((_, k) =>
          PHRASES.map((p, i) => (
            <span
              key={`${k}-${i}`}
              className="marquee-text text-3xl md:text-5xl text-black mx-8 inline-flex items-center gap-6"
            >
              {p}
              <Egg className="w-6 h-6 md:w-8 md:h-8" />
            </span>
          ))
        )}
      </Marquee>
    </div>
  );
}
